import { post, get } from "../network/index.js";

//查询用户
const queryMercUser = (data) => {
  return post("/mercWebi/userInfo/queryMercUser", data);
};

//创建用户
const addMercUser = (data) => {
  return post("/mercWebi/userInfo/addMercUser", data);
};


//新增用户地址
const userAddress = (data) => {
  return post("/mercWebi/userAddress/add", data);
};


//团购订单提交接口
const commitGroupOrder = (data) => {
  return post("/mercWebi/order/commitGroupOrder", data);
};



//查询用户地址详情
const getUserAddressDetail = (data) => {
  return post("/mercWebi/userAddress/getUserAddressDetail", data);
};


//查询用户地址
const getUserAddressList = (data) => {
  return post("/mercWebi/userAddress/getUserAddressList", data);
};

//商家团购管理 --> 开单选择团购列表
const queryGroupList = (data) => {
  return post("/mercWebi/webGroupInfo/queryGroupList", data);
};

//商家团购管理 --> 开单选择店铺列表
const queryGroupStoreList = (data) => {
  return post("/mercWebi/webGroupInfo/queryGroupStoreList", data);
};

//商家团购管理 --> 查询商家团购列表信息
const listGroupInfoByMercId = (data) => {
  return post("/mercWebi/webGroupInfo/listGroupInfoByMercId", data);
};
//商家团购管理 --> 查询商家团购列表信息
const querySpec  = (data) => {
  return get("/mercWebi/webGroupInfo/listGroupSpecByGroupId", data);
};


//商家团购管理 --> 查询用户订单列表
const queryUserOrderList= (data) => {
  return post("/mercWebi/order/queryUserOrderList", data);
};
//商家团购管理 --> 获取订单劵码列表
const queryCodeByOrderNo = (data) => {
  return post("/mercWebi/subscribeOrder/queryCodeByOrderNo", data);
};
//商家团购管理 --> 新增家政订单
const applyOrder = (data) => {
  return post("/mercWebi/subscribeOrder/applyOrder", data);
};

//商家后台 --> 售后服务
const aftermarketSubscribeOrder = (data) => {
  return post("/mercWebi/subscribeOrder/aftermarketSubscribeOrder", data);
};
//用户优卡列表
const queryCardList = (data) => {
  return post("/mercWebi/userInfo/queryCardList", data);
};
//查询商家开通的第三方列表
const listTrilateralMercByParam = (data) => {
  return post("/mercWebi/trilateralManager/listTrilateralMercByParam", data);
};
//删除地址
const delAddress = (data) => {
  return post("/mercWebi/userAddress/delete", data);
};



export default {
  queryMercUser,
  addMercUser,
  userAddress,
  getUserAddressDetail,
  getUserAddressList,
  queryGroupList,
  queryGroupStoreList,
  listGroupInfoByMercId,
  querySpec,
  commitGroupOrder,
  queryUserOrderList,
  queryCodeByOrderNo,
  applyOrder,
  aftermarketSubscribeOrder,
  queryCardList,
  listTrilateralMercByParam,
  delAddress
};
